export default class {
  constructor() {
    this.$modal = $(".js-video-modal");
    this.$open = $(".js-video-modal-btn");
    this.$gallery = this.$open.parents(".gallery");
  }

  init() {
    this.$gallery.on("click", ".js-video-modal-btn", (e) => {
      e.preventDefault();
      this.setVideo($(e.currentTarget).data("video"));
      this.$modal.modal("show");
    });

    this.$open.click((e) => {
      e.preventDefault();
      this.setVideo($(e.currentTarget).data("video"));
      this.$modal.modal("show");
    });

    this.$modal.on("hide.bs.modal", () => {
      this.setVideo("");
    });
  }

  setVideo(video) {
    this.$modal.find("iframe").attr("src", video);
  }
}
